import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datefrench'
})



export class DateFPipe implements PipeTransform {
  transform(start_date:any): any {
    let days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    let months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];
    let month_names_short = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'];
    let d = new Date(start_date.replace(/ /g,"T"));
     let dayname = days[d.getUTCDay()];
    let day = d.getUTCDate();
    let hours = d.getHours();
    let year = d.getFullYear();
    //console.log(start_date)
    let month = month_names_short[d.getMonth()];
    return dayname +' '+day+' '+month+' . '+year;
  }
}
